import environment from '@/environment'

// Coralogix RUM must not report from a local dev server. `VITE_APP_ENVIRONMENT_NAME` is commonly
// set to `staging` locally, because `npm start` already talks to the staging API, which would make
// local sessions and session recordings indistinguishable from real staging traffic in Coralogix.
//
// `isDevelopmentMode` is derived from `NODE_ENV`, which Vite resolves at build time: it is `true`
// only when served by the dev server and `false` in every deployed build, so it cannot be spoofed
// by `VITE_APP_ENVIRONMENT_NAME`.
//
// Set `VITE_APP_CORALOGIX_RUM_ENABLED=true` to opt back in when deliberately debugging RUM locally.
export function shouldInitializeCoralogixRum(): boolean {
  // An explicit flag wins in both directions, so RUM can also be switched off where it is deployed.
  if (environment.coralogixRumEnabled !== undefined) {
    return environment.coralogixRumEnabled
  }

  return !environment.isDevelopmentMode
}
